import React, { useState } from 'react'

import { Helmet } from 'react-helmet'


import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import Photos from "../components/photos";

import Footer from '../components/footer'
import './gallery.css'

const Gallery = (props) => {
  const [index, setIndex] = useState(-1);

  return (
    <div className="profile-container">
    <div className='profile-container01'>
      <Helmet>
        <title>Gallery</title>
        <meta property="og:title" content="Gallery - TripleC Therapy" />
      </Helmet>
      <div className="profile-image">
        <div className="profile-bg"></div>
        <div className='gallery-header-text'>
        <h1 className="home-text">GALLERY</h1>
        </div>
      </div>
      </div>

<div className='gallery-bg'>
<span className="home-text03 textXL">
Explore our gallery to witness the transformative power of hijama therapy! This collection showcases our serene treatment environment, the experiences of our clients, and the skilled practitioners dedication to your well-being. 
Each image tells a story of healing, renewal, and holistic health—visual proof of the positive impact hijama can have on your life.
<br />
<br />
In this gallery, you will find a curated collection of images that illustrate the art and science behind hijama. From the meticulous preparation of the treatment space to the skilled application of cupping and massage  techniques, this archive sheds light on  this time-honored therapy.
            </span>
    <div className="gallery">
      <RowsPhotoAlbum photos={Photos} targetRowHeight={150} onClick={({ index }) => setIndex(index)} />

      <Lightbox
        slides={Photos}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Thumbnails]}
      />
      </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Gallery
